type Variants = "outline" | "sharp"
export type Icon = Icon.Name | `${Icon.Name}-${Variants}` | Icon.Logo

export namespace Icon {
	const names: Record<string, string | undefined> & { "*": string } = {
		"*": "https://ionicons.pages.dev/svg/${name}.svg",
	}
	const cache: { [url: string]: Promise<string | undefined> | undefined } = {}
	async function fetch(url: string): Promise<string | undefined> {
		try {
			const response = await globalThis.fetch(url)
			if (!response.ok) {
				console.warn(`Icon failed to load: ${url} (Status: ${response.status})`)
				return undefined
			}
			return await response.text()
		} catch (error) {
			console.error(`Network error while fetching icon: ${url}`, error)
			return undefined
		}
	}
	export async function load(name: string): Promise<string | undefined> {
		const url = (names[name] ?? names["*"]).replace("${name}", name)
		return cache[url] ?? (cache[url] = fetch(url))
	}
	export function add(url: string, ...name: string[]): void {
		for (const n of name) {
			names[n] = url
		}
	}

	export type Name = (typeof Name.values)[number]
	export namespace Name {
		export const values = [
			"accessibility",
			"add-circle",
			"add",
			"airplane",
			"alarm",
			"albums",
			"alert-circle",
			"alert",
			"american-football",
			"analytics",
			"aperture",
			"apps",
			"archive",
			"arrow-back-circle",
			"arrow-back",
			"arrow-down-circle",
			"arrow-down",
			"arrow-forward-circle",
			"arrow-forward",
			"arrow-redo-circle",
			"arrow-redo",
			"arrow-undo-circle",
			"arrow-undo",
			"arrow-up-circle",
			"arrow-up",
			"at-circle",
			"at",
			"attach",
			"backspace",
			"bag",
			"bag-add",
			"bag-check",
			"bag-handle",
			"balloon",
			"ban",
			"bandage",
			"barbell",
			"bar-chart",
			"barcode",
			"baseball",
			"basketball",
			"basket",
			"battery-charging",
			"battery-dead",
			"battery-full",
			"battery-half",
			"beaker",
			"bed",
			"beer",
			"bicycle",
			"bluetooth",
			"boat",
			"body",
			"bonfire",
			"bowling-ball",
			"bookmarks",
			"bookmark",
			"book",
			"briefcase",
			"browsers",
			"brush",
			"bug",
			"build",
			"bulb",
			"business",
			"bus",
			"cafe",
			"calculator",
			"calendar",
			"calendar-clear",
			"calendar-number",
			"call",
			"camera-reverse",
			"camera",
			"card",
			"caret-back-circle",
			"caret-back",
			"caret-down-circle",
			"caret-down",
			"caret-forward-circle",
			"caret-forward",
			"caret-up-circle",
			"caret-up",
			"car-sport",
			"car",
			"cart",
			"cash",
			"cellular",
			"chatbox-ellipses",
			"chatbox",
			"chatbubble-ellipses",
			"chatbubbles",
			"chatbubble",
			"checkbox",
			"checkmark-circle",
			"checkmark-done-circle",
			"checkmark-done",
			"checkmark",
			"chevron-back-circle",
			"chevron-back",
			"chevron-collapse",
			"chevron-down-circle",
			"chevron-down",
			"chevron-expand",
			"chevron-forward-circle",
			"chevron-forward",
			"chevron-up-circle",
			"chevron-up",
			"clipboard",
			"close-circle",
			"close",
			"cloud-circle",
			"cloud-done",
			"cloud-download",
			"cloud-offline",
			"cloud",
			"cloud-upload",
			"cloudy-night",
			"cloudy",
			"code-download",
			"code-slash",
			"code",
			"code-working",
			"cog",
			"color-fill",
			"color-filter",
			"color-palette",
			"color-wand",
			"compass",
			"construct",
			"contract",
			"contrast",
			"copy",
			"create",
			"crop",
			"cube",
			"cut",
			"desktop",
			"diamond",
			"dice",
			"disc",
			"document-attach",
			"document-lock",
			"documents",
			"document",
			"document-text",
			"download",
			"duplicate",
			"ear",
			"earth",
			"easel",
			"egg",
			"ellipse",
			"ellipsis-horizontal-circle",
			"ellipsis-horizontal",
			"ellipsis-vertical-circle",
			"ellipsis-vertical",
			"enter",
			"exit",
			"expand",
			"eyedrop",
			"eye-off",
			"eye",
			"fast-food",
			"female",
			"file-tray-full",
			"file-tray-stacked",
			"file-tray",
			"film",
			"filter",
			"filter-circle",
			"finger-print",
			"fish",
			"fitness",
			"flag",
			"flame",
			"flashlight",
			"flash-off",
			"flash",
			"flask",
			"flower",
			"folder-open",
			"folder",
			"football",
			"footsteps",
			"funnel",
			"game-controller",
			"gift",
			"git-branch",
			"git-commit",
			"git-compare",
			"git-merge",
			"git-network",
			"git-pull-request",
			"glasses",
			"globe",
			"golf",
			"grid",
			"hammer",
			"hand-left",
			"hand-right",
			"happy",
			"hardware-chip",
			"headset",
			"heart-circle",
			"heart-dislike-circle",
			"heart-dislike",
			"heart-half",
			"heart",
			"help-buoy",
			"help-circle",
			"help",
			"home",
			"hourglass",
			"ice-cream",
			"id-card",
			"images",
			"image",
			"infinite",
			"information-circle",
			"information",
			"journal",
			"invert-mode",
			"keypad",
			"key",
			"language",
			"laptop",
			"layers",
			"leaf",
			"library",
			"link",
			"list-circle",
			"list",
			"locate",
			"location",
			"lock-closed",
			"lock-open",
			"log-in",
			"log-out",
			"magnet",
			"mail-open",
			"mail",
			"mail-unread",
			"male-female",
			"male",
			"man",
			"map",
			"medal",
			"medical",
			"medkit",
			"megaphone",
			"menu",
			"mic-circle",
			"mic-off-circle",
			"mic-off",
			"mic",
			"moon",
			"move",
			"musical-notes",
			"musical-note",
			"navigate-circle",
			"navigate",
			"newspaper",
			"notifications-circle",
			"notifications-off-circle",
			"notifications-off",
			"notifications",
			"nuclear",
			"nutrition",
			"open",
			"options",
			"paper-plane",
			"partly-sunny",
			"pause-circle",
			"pause",
			"paw",
			"pencil",
			"people-circle",
			"people",
			"person-add",
			"person-circle",
			"person-remove",
			"person",
			"phone-landscape",
			"phone-portrait",
			"pie-chart",
			"pin",
			"pint",
			"pizza",
			"planet",
			"play-back-circle",
			"play-back",
			"play-circle",
			"play-forward-circle",
			"play-forward",
			"play-skip-back-circle",
			"play-skip-back",
			"play-skip-forward-circle",
			"play-skip-forward",
			"play",
			"podium",
			"power",
			"pricetags",
			"prism",
			"pricetag",
			"print",
			"pulse",
			"push",
			"qr-code",
			"radio-button-off",
			"radio-button-on",
			"radio",
			"rainy",
			"reader",
			"receipt",
			"recording",
			"refresh-circle",
			"refresh",
			"reload-circle",
			"reload",
			"remove-circle",
			"remove",
			"reorder-four",
			"reorder-three",
			"reorder-two",
			"repeat",
			"resize",
			"restaurant",
			"return-down-back",
			"return-down-forward",
			"return-up-back",
			"return-up-forward",
			"ribbon",
			"rocket",
			"rose",
			"sad",
			"save",
			"scan-circle",
			"scale",
			"scan",
			"school",
			"search-circle",
			"search",
			"send",
			"server",
			"settings",
			"shapes",
			"share-social",
			"share",
			"shield-checkmark",
			"shield-half",
			"shield",
			"shirt",
			"shuffle",
			"skull",
			"snow",
			"sparkles",
			"speedometer",
			"square",
			"star-half",
			"star",
			"stats-chart",
			"stop-circle",
			"stop",
			"stopwatch",
			"storefront",
			"subway",
			"sunny",
			"swap-horizontal",
			"swap-vertical",
			"sync-circle",
			"sync",
			"tablet-landscape",
			"tablet-portrait",
			"telescope",
			"tennisball",
			"terminal",
			"text",
			"thermometer",
			"thumbs-down",
			"thumbs-up",
			"thunderstorm",
			"ticket",
			"timer",
			"time",
			"today",
			"toggle",
			"trail-sign",
			"train",
			"transgender",
			"trash-bin",
			"trash",
			"trending-down",
			"trending-up",
			"triangle",
			"trophy",
			"tv",
			"umbrella",
			"unlink",
			"videocam-off",
			"walk",
			"wallet",
			"warning",
			"watch",
			"water",
			"videocam",
			"wifi",
			"wine",
			"volume-high",
			"volume-low",
			"volume-medium",
			"volume-mute",
			"volume-off",
			"woman",
		] as const
	}
	export type Logo = (typeof Logo.values)[number]
	export namespace Logo {
		export const values = [
			"logo-alipay",
			"logo-amazon",
			"logo-amplify",
			"logo-android",
			"logo-angular",
			"logo-apple-appstore",
			"logo-apple",
			"logo-apple-ar",
			"logo-behance",
			"logo-bitbucket",
			"logo-bitcoin",
			"logo-buffer",
			"logo-capacitor",
			"logo-chrome",
			"logo-closed-captioning",
			"logo-codepen",
			"logo-css3",
			"logo-designernews",
			"logo-deviantart",
			"logo-discord",
			"logo-docker",
			"logo-dribbble",
			"logo-dropbox",
			"logo-edge",
			"logo-electron",
			"logo-euro",
			"logo-facebook",
			"logo-firebase",
			"logo-firefox",
			"logo-flickr",
			"logo-foursquare",
			"logo-github",
			"logo-gitlab",
			"logo-google-playstore",
			"logo-google",
			"logo-hackernews",
			"logo-html5",
			"logo-instagram",
			"logo-ionic",
			"logo-ionitron",
			"logo-javascript",
			"logo-laravel",
			"logo-linkedin",
			"logo-markdown",
			"logo-mastodon",
			"logo-medium",
			"logo-microsoft",
			"logo-nodejs",
			"logo-no-smoking",
			"logo-npm",
			"logo-octocat",
			"logo-paypal",
			"logo-pinterest",
			"logo-playstation",
			"logo-pwa",
			"logo-python",
			"logo-react",
			"logo-reddit",
			"logo-rss",
			"logo-sass",
			"logo-skype",
			"logo-slack",
			"logo-snapchat",
			"logo-soundcloud",
			"logo-stackoverflow",
			"logo-steam",
			"logo-stencil",
			"logo-tableau",
			"logo-tiktok",
			"logo-tumblr",
			"logo-tux",
			"logo-twitch",
			"logo-twitter",
			"logo-usd",
			"logo-web-component",
			"logo-venmo",
			"logo-whatsapp",
			"logo-vercel",
			"logo-vimeo",
			"logo-windows",
			"logo-vk",
			"logo-wordpress",
			"logo-vue",
			"logo-xbox",
			"logo-xing",
			"logo-yahoo",
			"logo-yen",
			"logo-youtube",
		] as const
	}
}
